//
//  SDKExporterCustomBlockVariant.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ExporterCustomBlockVariant {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, blockKey) {
        this.blockKey = blockKey;
        this.variantKey = model.key;
        this.name = model.name;
        this.isDefault = Object.hasOwn(model, "isDefault") ? model.isDefault : false;
    }
}
